import { type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { z } from "zod";
import { EmployerStatus } from "../types";

export type WlkpCompanyVillage = {
  id: string;
  subDistrictId: string;
  name: string;
  code: string;
  latitude: string;
  longitude: string;
  subDistrict: {
    id: string;
    cityId: string;
    name: string;
    code: string;
    city: {
      id: string;
      provinceId: string;
      name: string;
      district: boolean;
      code: string;
      latitude: string;
      longitude: string;
      province: {
        id: string;
        name: string;
        code: string;
        latitude: string;
        longitude: string;
      };
    };
  };
};

export type WlkpCompanyBusiness = {
  id: string;
  businessCategoryId: string;
  name: string;
  code: string;
};

export type WlkpCompany = {
  id?: string;
  name: string;
  description: string | null;
  email: string;
  address: string;
  phone: string;
  website: string | null;
  latitude: number | null;
  longitude: number | null;
  wlkpCode: string;
  status: string;
  nib: string;
  npwp: string | null;
  companyType: string | null;
  companyableType: string;
  totalMaleEmployees: number;
  totalFemaleEmployees: number;
  totalActiveEmployees: number;
  employeeSizeCategory: string;
  npp: string | null;
  totalBpjstkMembers: number;
  hasActiveReport: boolean;
  isReporterBpjstkRegistered: boolean;
  villageId: string;
  businessId: string;
  ownershipId: string | null;
  capitalId: string | null;
  logoPath: string | null;
  bannerPath: string | null;
  zipCode: string;
  village: WlkpCompanyVillage;
  business: WlkpCompanyBusiness;
  logoUri: string;
  bannerUri: string;
  completed: boolean;
};

export const wlkpCompanyEmployerBasicRegistrationSchema = z.object({
  industry: z.looseObject<ComboboxOption>({} as ComboboxOption, "Industri harus dipilih"),
  pic_name: z.string("Nama PIC harus diisi").min(1, "Nama PIC harus diisi"),
  pic_id_number: z.string("NIK PIC harus diisi").min(1, "NIK PIC harus diisi"),
  pic_email: z.email("Format email tidak tepat").min(1, "Email PIC harus diisi"),
  pic_phone: z
    .string("Nomor telepon PIC harus diisi")
    .regex(/^[0-9]+$/, "Nomor telepon tidak valid"),
});
export type WlkpCompanyEmployerBasicRegistrationDto = z.infer<typeof wlkpCompanyEmployerBasicRegistrationSchema>;

export type RegisterCompanyEmployerDto = {
  wlkp_code: string;
  industry_id: string;
  pic_name: string;
  pic_id_number: string;
  pic_email: string;
  pic_phone: string;
};

export interface WlkpCompanyEmployerRegistrationResponse {
  data: {
    id: string;
    userId: string;
    slug: string;
    name: string;
    status: EmployerStatus;
    employable: {
      id: string;
      wlkpCode: string;
      wlkpCompanyId: string | null;
      nib: string;
      kbliBusinessId: string | null;
      industryId: string;
      establishmentDate: string;
      picName: string;
      picIdNumber: string;
      picEmail: string;
      picPhone: string | null;
      createdAt: string;
      updatedAt: string;
    };
    address: string;
    postalCode: string | null;
    villageId: string;
    latitude: number;
    longitude: number;
    phone: string;
    email: string;
    website: string | null;
    description: string | null;
    logoFileId: string | null;
    logoUri: string;
    sla: string | null;
    submittedAt: string | null;
    verifiedAt: string | null;
    createdAt: string;
    updatedAt: string;
  };
}
